import { TirePressureDtoResponse } from "./tire-pressure.dto-response";
import { AccessoryCategory } from "../Constants";
import { NormalizeQtyPipe } from '../../shared/pipe/normalize-qty.pipe';
import { InventoryDtoResponse, InventoryDetailDtoResponse } from './inventory.dto-response';
import { TireSideWallDtoResponse } from './tire-sidewall.dto-response';

export class PackageBuilderSummaryProduct {
  imgURL: string;
  description: string;
  longSKU: string;
  shortSKU: string;
  pairNo: string;
  qty: number;
  retailPrice: number;
  customerPrice: number;
  totalPrice: number;
  warningNotes: string[];
  // djb:warning-this exposes deep discrepencies between Categories db and internal/manual HardwareAccessoryTypes
  // When changed back to AccessoryCategory, the compiler will point the problems
  // this design issue needs to be addressed at some point
  //accessoryType: AccessoryCategory;
  accessoryType: number;
  tirePressure: TirePressureDtoResponse[];
  tireSideWallSelected: TireSideWallDtoResponse;
  inventory: InventoryDtoResponse;
  onHandDetails: InventoryDetailDtoResponse[];
  //JD
  offset: number;
  landedCost: number;
  isConcept: boolean;
  productStatus: string;

  isOnSpecial: boolean;
  isOnSpecialAtDealerCost: boolean;
  isOnSpecialMaxQty: number;
  dealerCost: number;
  isNationalAccountItem: boolean;
  position: string;
  get shortSkuLabel(): string {
    return "FC.Label.Sku";
  }

  get longSkuLabel(): string {
    if (this.accessoryType === AccessoryCategory.Studding || this.accessoryType === AccessoryCategory.Mounting) {
      return "FC.Label.Service";
    }
    return "FC.Label.Part";
  }
}
